<template>
  <div class="r-integration common-flex" v-if="customerInfoShow">
    <!-- $t('newOrder.customerPlaceholder') -->
    <form>
      <Select
        ref='customerSelect'
        v-model="chooseId"
        placeholder=""
        filterable
        :default-label="customerName"
        :remote-method="remoteMethod"
        @on-change="changeCustomer"
        style="width: 172px"
      >
        <Option v-for="item in customer" :value="item.id" :key="item.id">{{
          item.custName
        }}</Option>
      </Select>
    </form>
    <div class="details iconfont iconxiangqing"></div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: "r-integration",
  data() {
    return {
      // customerId: "",
      chooseId: "",
      customer: [
        
      ],
    };
  },
  watch: {
    customerList: {
      handler(newval, oldval) {
        this.customer = newval;
      },
      deep: true,
      immediate: true,
    },
    customerId: {
      handler(newval, oldval) {
        this.chooseId = Number(newval);
        console.log('this.chooseId',this.chooseId)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions([
      'getCustAction'
    ]),
    changeCustomer(e) {
      // console.log("e", e);
      this.customer.map((item) => {
        if (e == item.id) {
          this.$emit("chooseCustomer", item);
        }
      });
    },
    remoteMethod(e) {
      this.getCustAction({ keywords: e }).then((res) => {
        // console.log("res", res);
        this.customer = res.data;
      });
    },
  },
  props: {
    customerList: Array,
    customerId: [Number, String],
    customerName: String,
    customerInfoShow: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-integration {
  /deep/.ivu-select-selection {
    height: 40px;
    line-height: 40px;
    color: #0a4dcc;
    background: #e6edf9;
  }
  /deep/.ivu-icon {
    color: #0a4dcc;
    background: #e6edf9;
  }
  /deep/.ivu-select-placeholder {
    height: 40px;
    line-height: 40px;
  }
  /deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 40px;
    line-height: 40px;
    color: #0a4dcc;
    background: #e6edf9;
  }
  /deep/.ivu-select-input{
  color:#0A4DCC;
  font-weight: 700;
  font-size: 16px;
}
  /deep/.ivu-select-item{
    position: relative;
    
}
  /deep/.ivu-select-item::after{
    content: "";
    position: absolute;
    width: 90%;
    left: 10%;
    bottom: 0;
    height: 1px;
    background: #EEEEEE;
}
  .details {
    width: 40px;
    height: 40px;
    background: #e6edf9;
    border-radius: 4px;
    margin-left: 10px;
  }
  .iconxiangqing {
    color: #0a4dcc;
    font-size: 17px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-integration.vue